import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Addaddress from './addaddress';
import $ from "jquery";
import Server from '../../../functions/server';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Address extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'lg',
    data: []
  };

  getAddress() {
    let context = this;
    context.setState({ data: [], load: true, message: 'Getting Address!!!' })
    $.ajax({
      type: 'POST',
      data: { 'cid': context.props.cid },
      url: Server() + 'machinecustomer/getaddress.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ data: data, open: true })
        } catch (e) {
          alert('Error!!!');
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleMaxWidthChange = event => {
    this.setState({ maxWidth: event.target.value });
  };

  handleFullWidthChange = event => {
    this.setState({ fullWidth: event.target.checked });
  };

  delete(id) {
    let context = this;
    let orignalData = this.state.data;
    $.ajax({
      type: 'POST',
      data: { 'id': id },
      url: Server() + 'machinecustomer/deleteaddress.php',
      success: function(data)
      {
        context.setState({ load: false })
        let items = [];
        if (data == 1) {
          orignalData.map((c) => {
            if (c.id != id) {
              items.push(c);
            }
          })
          context.setState({ data: items })
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    const { classes } = this.props;
    let i = 0;
    return (
      <React.Fragment>
        <div onClick={this.getAddress.bind(this)}>Address</div>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Address</DialogTitle>
          <DialogContent>
            { this.props.menuPermission.add ?
              <Addaddress cid={this.props.cid} getAddress={this.getAddress.bind(this)} type='add'/>:''
            }
            <br/><br/>
            <table width="100%" id="table">
              <tr>
                <th id='tableheader'><center>Sino</center></th>
                <th id='tableheader'><center>Address</center></th>
                <th id='tableheader'><center>Taluk</center></th>
                <th id='tableheader'><center>District</center></th>
                <th id='tableheader'><center>State</center></th>
                <th id='tableheader'><center>Pincode</center></th>
                <th id='tableheader'><center>GSTIN</center></th>
                { this.props.menuPermission.edit ?
                  <th id='tableheader'><center>Edit</center></th>:''
                }
                { this.props.menuPermission.cancel ?
                  <th id='tableheader'><center>Delete</center></th>:''
                }
              </tr>
              { this.state.data.map((x) => {
                  i++;
                  return (
                    <tr>
                      <td><center>{i}</center></td>
                      <td><center>{x.address}</center></td>
                      <td><center>{x.taluk}</center></td>
                      <td><center>{x.district}</center></td>
                      <td><center>{x.state}</center></td>
                      <td><center>{x.pincode}</center></td>
                      <td><center>{x.GSTIN}</center></td>
                      { this.props.menuPermission.edit ?
                        <td id='pointer'><center><Addaddress cid={this.props.cid} type='edit' data={x} getAddress={this.getAddress.bind(this)}/></center></td>:''
                      }
                      { this.props.menuPermission.cancel ?
                        <td id='pointer' onClick={this.delete.bind(this, x.id)}><center>Delete</center></td>:''
                      }
                    </tr>
                  )
                })
              }
            </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

Address.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Address);
